let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7QxF5")).then(() => parcelRequire('aGEG4'));